<script>
import { hasSomeParentWithClass, getParentWithClass } from '../api/HelperFunctions.js';
import Vue from 'vue';

export default {
  name: 'ClickOutside',
  bind(el, binding) {
    let fn = binding.value;
    const handler = function(event) {
      if (!el.contains(event.target) && el !== event.target) {
        fn(event, el);
      }
    };
    el.__vueCLickOutside__ = handler;
    //Podpięcie zdarzenia do elementu body.
    document.body.addEventListener('click', handler);
    //Wykonywane w następnej iteracji, by element został już dodany do DOM.
    Vue.nextTick(() => {
      //Sprawdzamy, czy element został wyświetlony w oknie modalnym, jeśli tak, należy podpiąć zdarzenie do elementu okna.
      if (hasSomeParentWithClass(el, 'modal-content')) {
        const parentElement = getParentWithClass(el, 'modal-content');
        el.__vueClickOutsideModal__ = parentElement;
        parentElement.addEventListener('click', handler);
      }
    });
  },
  unbind(el) {
    document.body.removeEventListener('click', el.__vueCLickOutside__);
    if (el.__vueClickOutsideModal__) {
        el.__vueClickOutsideModal__.removeEventListener('click', el.__vueCLickOutside__);
        el.__vueClickOutsideModal__ = null;
    }
    el.__vueCLickOutside__ = null;
  }
};
</script>